
//production settings
export const oidcSettings = {
  authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a/v2.0/',
  clientId: 'e0df44ce-631d-4735-a452-6058e75a47f5',
  redirectUri: 'https://navigator-au-tools.siemens.cloud/oidc-callback',
  //silentRedirectUri: 'https://navigator-au-tools.siemens.cloud/oidc-silent-renew.html', //silent renew doesn't work because of csp policies
  //automaticSilentRenew: true,
  responseType: 'code',
  scope: 'openid profile email', //default was "openid profile"

}

/*

//test settings
export const oidcSettings = {
  authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a/v2.0/',
  clientId: 'e0df44ce-631d-4735-a452-6058e75a47f5', 
  redirectUri: 'http://localhost:8080/oidc-callback',
  //silentRedirectUri: 'http://localhost:8081/oidc-silent-renew.html',  
  //automaticSilentRenew: true,
  responseType: 'code',
  scope: 'api://test', //default was "openid profile"

}

*/

